// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Card,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Table,
//   CardFooter,
//   Row,
// } from 'reactstrap';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { useSelector } from 'react-redux';
// import { formatDate } from '../../constants/DateFormatter';

// const StudentAc = ({ systemData }) => {
//   const navigate = useNavigate();
//   const [acList, setAcList] = useState([]);
//   const [apiResponse, setApiResponse] = useState({});
//   const [classMasterData, setClassMasterData] = useState([]);
//   const sessionData = useSelector((state) => state.sessionState);
//   const location = useLocation();

//   const [search, setSearch] = useState("");
//   const [fromDate, setfromDate] = useState(sessionData.session_start_date);
//   const [toDate, settoDate] = useState(sessionData.session_end_date);
 

//   const onHandleEditParty = (id) => {
//     let findArrayData = acList.find((e) => e.id === id);
//     navigate('/addAdmission', { state: { ...findArrayData } });
//   };



//   const fetchData = async () => {
//     try {
//       const queryParams = new URLSearchParams();

//       queryParams.append("session", sessionData.session_year);
//       queryParams.append("adm_no", location.state.admit_no);
//       queryParams.append("toDate", toDate);
//       queryParams.append("fromDate", fromDate);


//       const response = await apiService.get(`api/FeeReciept/GetStudentFeeAcSummary?${queryParams.toString()}`);
//       console.log(response)

//       if (response.status === true) {
//         setApiResponse(response);
//         setAcList(response.studentFeeAcSummary)
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     GetCurrectClassInfo();
//   }, [search, toDate, fromDate]);


//   // useEffect(() => {
//   //   GetAdmission();
//   // }, [!acList]);

//   const tableRef = useRef();

//   const GetCurrectClassInfo = async () => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       const response = await apiService.get(
//         `api/Admission/GetClass_MasterGroupData`,
//         config
//       );

//       setClassMasterData(response.item2);
//     } catch (error) {
//       console.log(error);
//       alert('SomeThing went wrong');
//     }
//   };


//   // const onHandleEdit = (id) => {
//   //   let findArrayData = Fee_Reciept_Master_data.find((e) => e.id === id);
//   //   navigate('/save-fee-reciept', {
//   //     state: { ...findArrayData },
//   //   });
//   // };

//   return (
//     <>
// <Col lg="12">
//   <Card className="shadow-sm">
//     {/* Card Title */}
//     <CardTitle
//       tag="h6"
//       className="p-3 mb-0 d-flex align-items-center justify-content-between bg-light rounded-top"
//     >
//       <div className="d-flex align-items-center">
//         <i className="bi bi-card-text me-2 fs-5"></i>
//         Student A/c
//       </div>
//     </CardTitle>

//     <div className="px-4 py-3 border-bottom">
//   <Row className="align-items-start g-3">
//     {/* Student Info Section */}
//     <Col md={6}>
//       <Row>
        
//       <Col xs={12}>
//           <strong>Admission No:</strong> {location.state.admit_no}
//         </Col>
//         <Col xs={12}>
//           <strong>Student Name:</strong> {location.state.stud_name}
//         </Col>
//         <Col xs={12}>
//           <strong>Class:</strong> {location.state.curr_class}
//         </Col>
//         <Col xs={12}>
//           <strong>D.O.B:</strong> {formatDate(location.state.d_o_b)}
//         </Col>
//         <Col xs={12}>
//           <strong>Father Name:</strong> {location.state.f_name}
//         </Col>
//         <Col xs={12}>
//           <strong>Mobile No:</strong> {location.state.f_mob}
//         </Col>
//         <Col xs={12}>
//           <strong>Admission No:</strong> {location.state.admit_no}
//         </Col>
//       </Row>
//     </Col>

//     {/* Totals Summary */}
//     <Col md={6}>
//       <div className="d-flex flex-wrap justify-content-end gap-3">
//         <div className="p-3 bg-light border rounded text-center shadow-sm" style={{ minWidth: '160px' }}>
//           <h6 className="text-muted mb-1">Total Debit</h6>
//           <h5 className="text-danger mb-0">₹ {apiResponse.totalDebit? apiResponse.totalDebit : "0"}</h5>
//         </div>
//         <div className="p-3 bg-light border rounded text-center shadow-sm" style={{ minWidth: '160px' }}>
//           <h6 className="text-muted mb-1">Total Credit</h6>
//           <h5 className="text-success mb-0">₹ {apiResponse.totalCredit ? apiResponse.totalCredit : "0" }</h5>
//         </div>
//         <div className="p-3 bg-light border rounded text-center shadow-sm" style={{ minWidth: '330px' }}>
//           <h6 className="text-muted mb-1">Total Balance</h6>
//           <h5 className="text-primary mb-0">₹ {apiResponse.finalBalance ? apiResponse.finalBalance : "0"}</h5>
//         </div>
//       </div>
//     </Col>
//   </Row>
// </div>


//     {/* Date Filter */}
//     <div className="px-4 py-3 ">
//       <Row className="g-3 align-items-end">
//         <Col md={4}>
//         Student A/C Summary :-
//         </Col>
//         <Col md={8}>
//           <div className="input-group">
//             <span className="input-group-text">From Date</span>
//             <input
//               name="fromDate"
//               value={fromDate}
//               type="date"
//               onChange={(e) => setfromDate(e.target.value)}
//               className="form-control"
//             />
//             <span className="input-group-text">To Date</span>
//             <input
//               name="toDate"
//               value={toDate}
//               type="date"
//               onChange={(e) => settoDate(e.target.value)}
//               className="form-control"
//             />
//           </div>
//         </Col>
//       </Row>
//     </div>

//     {/* Table Section */}
//     <CardBody className="pt-0">
//       <div ref={tableRef} className="table-responsive">
//         <Table hover striped responsive className="align-middle mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Bill No</th>
//               <th>Date</th>
//               <th>Particulars</th>
//               <th>Credit (₹)</th>
//               <th>Debit (₹)</th>
//               <th>Balance (₹)</th>
//               <th>Trx Type</th>
//             </tr>
//           </thead>
//           <tbody>
//             {acList.length ? (
//               <>
//                 {acList.map((item, index) => {
//                   const isReceipt = item.trxType === "FEE RECEIPT";
//                   const cellStyle = isReceipt
//                     ? { backgroundColor: "#198754", color: "white" }
//                     : {};

//                   return (
//                     <tr key={index}>
//                       <td style={cellStyle}>{item.billNo}  
//                         {/* <i 
//                             style={{cursor:"pointer"}}
//                             onClick={() => onHandleEdit(item.id)}
//                             className='bi bi-pencil text-primary'></i> */}
//                       </td>
//                       <td style={{ ...cellStyle, whiteSpace: "nowrap", minWidth: "70px" }}>{formatDate(item.date)}</td>
//                       <td style={cellStyle}>{item.particulars}</td>
//                       <td style={cellStyle}>{item.credit}</td>
//                       <td style={cellStyle}>{item.debit}</td>
//                       <td style={cellStyle}>{item.balance}</td>
//                       <td style={cellStyle}>{item.trxType}</td>
//                     </tr>
//                   );
//                 })}
//                 <tr className="fw-bold bg-light ">
//                   <th colSpan={3}>TOTAL</th>
//                   <th className="text-danger">₹ {apiResponse.totalDebit}</th>
//                   <th className="text-success">₹ {apiResponse.totalCredit}</th>
//                   <th className="text-primary">₹ {apiResponse.finalBalance}</th>
//                   <th></th>
//                 </tr>
//               </>
//             ) : (
//               <tr>
//                 <td className="text-center" colSpan={7}>
//                   No data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       </div>
//     </CardBody>

  
//   </Card>
// </Col>


//     </>
//   );
// };

// export default StudentAc;
//
import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Col,
  CardTitle,
  CardBody,
  Button,
  Table,
  CardFooter,
  Row,
} from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { useSelector } from 'react-redux';
import { formatDate } from '../../constants/DateFormatter';

const StudentAc = ({ systemData }) => {
  const navigate = useNavigate();
  const [acList, setAcList] = useState([]);
  const [apiResponse, setApiResponse] = useState({});
  const [classMasterData, setClassMasterData] = useState([]);
  const sessionData = useSelector((state) => state.sessionState);
  const { user } = useSelector((state) => state.authState || {});
  const location = useLocation();

  const vendorId = user?.vendor_id || user?.vendorId || "";
  const branchId = user?.branch_id || user?.branchId || "";

  const [search, setSearch] = useState("");
  const [fromDate, setfromDate] = useState(sessionData.session_start_date);
  const [toDate, settoDate] = useState(sessionData.session_end_date);

  const onHandleEditParty = (id) => {
    let findArrayData = acList.find((e) => e.id === id);
    navigate('/addAdmission', { state: { ...findArrayData } });
  };

  const fetchData = async () => {
    try {
      const queryParams = new URLSearchParams();

      queryParams.append("session", sessionData.session_year);
      queryParams.append("enrollment_id", location.state.enrollment_id);
      queryParams.append("toDate", toDate);
      queryParams.append("fromDate", fromDate);
      queryParams.append("vendorId", vendorId);
      queryParams.append("branchId", branchId);

      const response = await apiService.get(
        `api/FeeReciept/GetStudentFeeAcSummary?${queryParams.toString()}`
      );
      //console.log(response);

      if (response.status === true) {
        setApiResponse(response);
        setAcList(response.studentFeeAcSummary);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    GetCurrectClassInfo();
  }, [search, toDate, fromDate]);

  const tableRef = useRef();

  const GetCurrectClassInfo = async () => {
    try {
      const response = await apiService.get(
        `api/Admission/GetClass_MasterGroupData?vendorId=${vendorId}&branchId=${branchId}&`
      );

      setClassMasterData(response.item2);
    } catch (error) {
      console.log(error);
      alert('SomeThing went wrong');
    }
  };

  return (
    <>
<Col lg="12">
  <Card className="shadow-sm">
    {/* Card Title */}


    <div className="px-4 py-3 border-bottom">
  <Row className="align-items-start g-3">
    {/* Student Info Section */}
    <Col md={6}>
      <Row>
        
      <Col xs={12}>
          <strong>Admission Number:</strong> {location.state.admit_no}
        </Col>
        <Col xs={12}>
          <strong>Student Name:</strong> {location.state.student_name}
        </Col>
        <Col xs={12}>
          <strong>Class:</strong> {location.state.course_name}
        </Col>
        {/* <Col xs={12}>
          <strong>D.O.B:</strong> {formatDate(location.state.d_o_b)}
        </Col>
        <Col xs={12}>
          <strong>Father Name:</strong> {location.state.f_name}
        </Col> */}
        <Col xs={12}>
          <strong>Mobile No:</strong> {location.state.stud_ph_no}
        </Col>
        <Col xs={12}>
          <strong>Session:</strong> {location.state.session_year}
        </Col>
      </Row>
    </Col>

    {/* Totals Summary */}
    <Col md={6}>
      <div className="row">
        <div className="p-3 col-sm-6 bg-light border rounded text-center shadow-sm">
          <h6 className="text-muted mb-1">Total Debit</h6>
          <h5 className="text-danger mb-0">₹ {apiResponse.totalDebit? apiResponse.totalDebit : "0"}</h5>
        </div>
        <div className="p-3 col-sm-6 bg-light border rounded text-center shadow-sm">
          <h6 className="text-muted mb-1">Total Credit</h6>
          <h5 className="text-success mb-0">₹ {apiResponse.totalCredit ? apiResponse.totalCredit : "0" }</h5>
        </div>
        <div className="p-3 col-sm-12 bg-light border rounded text-center shadow-sm mb-2">
          <h6 className="text-muted mb-1">Total Balance</h6>
          <h5 className="text-primary mb-0">₹ {apiResponse.finalBalance ? apiResponse.finalBalance : "0"}</h5>
        </div>
      </div>
    </Col>
  </Row>
</div>

          <div className="px-4 py-3 ">
            <Row className="g-3 align-items-end">
              <Col md={4}>
                Student A/C Summary :-
              </Col>
              <Col md={8}>
                <div className="input-group">
                  <span className="input-group-text">From Date</span>
                  <input
                    name="fromDate"
                    value={fromDate}
                    type="date"
                    onChange={(e) => setfromDate(e.target.value)}
                    className="form-control"
                  />
                  <span className="input-group-text">To Date</span>
                  <input
                    name="toDate"
                    value={toDate}
                    type="date"
                    onChange={(e) => settoDate(e.target.value)}
                    className="form-control"
                  />
                </div>
              </Col>
            </Row>
          </div>

    {/* Table Section */}
    <CardBody className="pt-0">
      <div ref={tableRef} className="table-responsive">
        <Table hover striped responsive className="align-middle mb-0">
          <thead className="table-primary">
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Particulars</th>
              <th>Credit (₹)</th>
              <th>Debit (₹)</th>
              <th>Balance (₹)</th>
              <th>Trx Type</th>
            </tr>
          </thead>
          <tbody>
            {acList.length ? (
              <>
                {acList.map((item, index) => {
                  const isReceipt = item.trxType === "FEE RECEIPT";
                  const cellStyle = isReceipt
                    ? { backgroundColor: "#198754", color: "white" }
                    : {};

                        return (
                          <tr key={index}>
                            <td style={cellStyle}>{item.billNo}</td>
                            <td style={{ ...cellStyle, whiteSpace: "nowrap", minWidth: "70px" }}>{formatDate(item.date)}</td>
                            <td style={cellStyle}>{item.particulars}</td>
                            <td style={cellStyle}>{item.credit}</td>
                            <td style={cellStyle}>{item.debit}</td>
                            <td style={cellStyle}>{item.balance}</td>
                            <td style={cellStyle}>{item.trxType}</td>
                          </tr>
                        );
                      })}
                      <tr className="fw-bold bg-light ">
                        <th colSpan={3}>TOTAL</th>
                        <th className="text-danger">₹ {apiResponse.totalDebit}</th>
                        <th className="text-success">₹ {apiResponse.totalCredit}</th>
                        <th className="text-primary">₹ {apiResponse.finalBalance}</th>
                        <th></th>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td className="text-center" colSpan={7}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default StudentAc;